// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_eJ","advertDetailHeaderPrice__value":"c-m_eK","advertDetailHeaderPrice__label":"c-m_eL"};